import { MenuList as ChakraMenuList } from '@chakra-ui/react';
import styled from '@emotion/styled';

export const MenuList = styled(ChakraMenuList)`
  padding: 0px;

  & > div:first-child {
    padding-top: 8px;
  }

  & > div:last-child {
    padding-bottom: 8px;
  }
`;
